var React = require('react');

function ToggleInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","d":"M3.5 7a3.5 3.5 0 110-7 3.5 3.5 0 010 7zM13 7a3.5 3.5 0 110-7 3.5 3.5 0 010 7zm9.5 0a3.5 3.5 0 110-7 3.5 3.5 0 010 7z"}));
}

ToggleInline.defaultProps = {"width":"26","height":"7","aria-hidden":"true","viewBox":"0 0 26 7"};

module.exports = ToggleInline;

ToggleInline.default = ToggleInline;
